import MMultiplex from './index.vue';
import MMultiplexItem from './item.vue';

export {
    MMultiplex,
    MMultiplexItem,
};

export default MMultiplex;
